var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-modal',{attrs:{"maskClosable":false,"visible":_vm.visible,"title":"重置密码","confirmLoading":_vm.confirmLoading,"destroyOnClose":""},on:{"ok":_vm.save,"cancel":_vm.cancel}},[_c('p',[_vm._v("密码将被重置为：zhlc123")])])}
var staticRenderFns = []

export { render, staticRenderFns }